import React                from "react";
import Store                from "Dashboard/Core/Store";
import Navigate             from "Dashboard/Core/Navigate";
import useForm              from "Dashboard/Hooks/Form";

// Components
import AuthContainer        from "Components/Utils/Auth/AuthContainer";
import AuthHeader           from "Components/Utils/Auth/AuthHeader";
import AuthForm             from "Components/Utils/Auth/AuthForm";

// Dashboard
import InputField           from "Dashboard/Components/Form/InputField";



/**
 * The Login Page
 * @returns {React.ReactElement}
 */
function LoginPage() {
    const { redirect } = Store.useState("core");
    const { login } = Store.useAction("auth");

    const navigate = Navigate.useGoto();


    // The Initial Data
    const initialData = {
        email    : "",
        password : "",
    };

    // Handles the Edit
    const handleEdit = async (params) => {
        try {
            const response = await login(params);
            resolveLogin(response);
        } catch (errors) {
            setErrors(errors);
        }
    };

    // Resolves the Login
    const resolveLogin = (result) => {
        if (result.reqPassChange) {
            navigate("PASS_CHANGE");
        } else {
            navigate(redirect);
        }
    };

    // The Form State
    const {
        loading, data, errors, handleChange, handleSubmit, setErrors,
    } = useForm("login", initialData, handleEdit, null, false);



    // Do the Render
    return <AuthContainer>
        <AuthHeader title="LOGIN_TITLE" />
        <AuthForm
            url="PASS_RECOVER"
            link="LOGIN_RECOVER"
            button="LOGIN_BUTTON"
            error={errors.form}
            onSubmit={handleSubmit}
            isLoading={loading}
        >
            <InputField
                type="email"
                name="email"
                label="GENERAL_EMAIL"
                value={data.email}
                error={errors.email}
                onChange={handleChange}
                isRequired
            />
            <InputField
                type="password"
                name="password"
                label="GENERAL_PASSWORD"
                value={data.password}
                error={errors.password}
                onChange={handleChange}
                isRequired
            />
        </AuthForm>
    </AuthContainer>;
}

export default LoginPage;
